import { createFileRoute } from '@tanstack/react-router';

import { getCitationOptions } from '@/module/Author/Citation/model/CitationQuery';

export const Route = createFileRoute(
  '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout',
)({
  loader: async ({ params: { translationId, citationId }, context: { queryClient } }) => {
    const citation = await queryClient.ensureQueryData(getCitationOptions(translationId, citationId));
    return {
      citation,
      breadcrumb: citation?.title ?? '',
    };
  },
});
